module.exports = __webpack_public_path__ + "distribution/img/ico_close4.af2267fa.svg";